<template>
  <file-manager-index :selectable="false" class="mt-2" />
</template>

<script>
import FileManagerIndex from "@/views/menu/file-manager/components/index.vue";
export default {
  name: "fileManager",
  components: { FileManagerIndex }
}
</script>